export enum PRODUCTS_FILTER {
    productType = 'productType',
    productFilter = 'productFilter',
    brand = 'brand',
    excludeProductTypes = 'excludeProductTypes',
}
